import { useEffect } from "react";

export default function PreFooter() {
  useEffect(() => {
    // Prevent loading the script multiple times
    if (!document.querySelector('script[src="https://elfsightcdn.com/platform.js"]')) {
      const script = document.createElement("script");
      script.src = "https://elfsightcdn.com/platform.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div className="prefooter" style={{padding: "2rem 0 0 0"}}>
      <div
        className="elfsight-app-70f809a7-fc6c-4997-b635-2221c490b127"
        data-elfsight-app-lazy
      />
    </div>
  );
}
